import { SvgIcons } from '@ngneat/svg-icon';

import { appClearDayDarkIcon } from '@icons/clear-day-dark';
import { appClearDayLightIcon } from '@icons/clear-day-light';
import { appClearNightDarkIcon } from '@icons/clear-night-dark';
import { appClearNightLightIcon } from '@icons/clear-night-light';
import { appCloudyDarkIcon } from '@icons/cloudy-dark';
import { appCloudyLightIcon } from '@icons/cloudy-light';
import { appFogDarkIcon } from '@icons/fog-dark';
import { appFogLightIcon } from '@icons/fog-light';
import { appHailDarkIcon } from '@icons/hail-dark';
import { appHailLightIcon } from '@icons/hail-light';
import { appNoneDarkIcon } from '@icons/none-dark';
import { appNoneLightIcon } from '@icons/none-light';
import { appPartlyCloudyDayDarkIcon } from '@icons/partly-cloudy-day-dark';
import { appPartlyCloudyDayLightIcon } from '@icons/partly-cloudy-day-light';
import { appPartlyCloudyNightDarkIcon } from '@icons/partly-cloudy-night-dark';
import { appPartlyCloudyNightLightIcon } from '@icons/partly-cloudy-night-light';
import { appRainDarkIcon } from '@icons/rain-dark';
import { appRainLightIcon } from '@icons/rain-light';
import { appSleetDarkIcon } from '@icons/sleet-dark';
import { appSleetLightIcon } from '@icons/sleet-light';
import { appSnowDarkIcon } from '@icons/snow-dark';
import { appSnowLightIcon } from '@icons/snow-light';
import { appThunderstormDarkIcon } from '@icons/thunderstorm-dark';
import { appThunderstormLightIcon } from '@icons/thunderstorm-light';
import { appWindDarkIcon } from '@icons/wind-dark';
import { appWindLightIcon } from '@icons/wind-light';

import { WeatherIconStoreModelEnum } from './weather.enums';

export interface WeatherIconViewModel {
  lightIcon: SvgIcons;
  darkIcon: SvgIcons;
  translationKey: string;
}

export const weatherIconAssets = [
  appClearDayDarkIcon,
  appClearDayLightIcon,
  appClearNightDarkIcon,
  appClearNightLightIcon,
  appThunderstormDarkIcon,
  appThunderstormLightIcon,
  appRainDarkIcon,
  appRainLightIcon,
  appSnowDarkIcon,
  appSnowLightIcon,
  appSleetDarkIcon,
  appSleetLightIcon,
  appWindDarkIcon,
  appWindLightIcon,
  appFogDarkIcon,
  appFogLightIcon,
  appCloudyDarkIcon,
  appCloudyLightIcon,
  appPartlyCloudyDayDarkIcon,
  appPartlyCloudyDayLightIcon,
  appPartlyCloudyNightDarkIcon,
  appPartlyCloudyNightLightIcon,
  appHailDarkIcon,
  appHailLightIcon,
  appNoneDarkIcon,
  appNoneLightIcon,
];

const weatherIconMapping: Record<WeatherIconStoreModelEnum, WeatherIconViewModel> = {
  [WeatherIconStoreModelEnum.ClearDay]: {
    lightIcon: appClearDayLightIcon.name,
    darkIcon: appClearDayDarkIcon.name,
    translationKey: 'enums.weather-icon.clear-day',
  },
  [WeatherIconStoreModelEnum.ClearNight]: {
    lightIcon: appClearNightLightIcon.name,
    darkIcon: appClearNightDarkIcon.name,
    translationKey: 'enums.weather-icon.clear-night',
  },
  [WeatherIconStoreModelEnum.Thunderstorm]: {
    lightIcon: appThunderstormLightIcon.name,
    darkIcon: appThunderstormDarkIcon.name,
    translationKey: 'enums.weather-icon.thunderstorm',
  },
  [WeatherIconStoreModelEnum.Rain]: {
    lightIcon: appRainLightIcon.name,
    darkIcon: appRainDarkIcon.name,
    translationKey: 'enums.weather-icon.rain',
  },
  [WeatherIconStoreModelEnum.Snow]: {
    lightIcon: appSnowLightIcon.name,
    darkIcon: appSnowDarkIcon.name,
    translationKey: 'enums.weather-icon.snow',
  },
  [WeatherIconStoreModelEnum.Sleet]: {
    lightIcon: appSleetLightIcon.name,
    darkIcon: appSleetDarkIcon.name,
    translationKey: 'enums.weather-icon.sleet',
  },
  [WeatherIconStoreModelEnum.Wind]: {
    lightIcon: appWindLightIcon.name,
    darkIcon: appWindDarkIcon.name,
    translationKey: 'enums.weather-icon.wind',
  },
  [WeatherIconStoreModelEnum.Fog]: {
    lightIcon: appFogLightIcon.name,
    darkIcon: appFogDarkIcon.name,
    translationKey: 'enums.weather-icon.fog',
  },
  [WeatherIconStoreModelEnum.Cloudy]: {
    lightIcon: appCloudyLightIcon.name,
    darkIcon: appCloudyDarkIcon.name,
    translationKey: 'enums.weather-icon.cloudy',
  },
  [WeatherIconStoreModelEnum.PartlyCloudyDay]: {
    lightIcon: appPartlyCloudyDayLightIcon.name,
    darkIcon: appPartlyCloudyDayDarkIcon.name,
    translationKey: 'enums.weather-icon.partly-cloudy-day',
  },
  [WeatherIconStoreModelEnum.PartlyCloudyNight]: {
    lightIcon: appPartlyCloudyNightLightIcon.name,
    darkIcon: appPartlyCloudyNightDarkIcon.name,
    translationKey: 'enums.weather-icon.partly-cloudy-night',
  },
  [WeatherIconStoreModelEnum.Hail]: {
    lightIcon: appHailLightIcon.name,
    darkIcon: appHailDarkIcon.name,
    translationKey: 'enums.weather-icon.hail',
  },
  [WeatherIconStoreModelEnum.None]: {
    lightIcon: appNoneLightIcon.name,
    darkIcon: appNoneDarkIcon.name,
    translationKey: 'enums.weather-icon.none',
  },
};

export const mapWeatherIconStoreModelToViewModel = (weatherIcon: WeatherIconStoreModelEnum): WeatherIconViewModel =>
  weatherIconMapping[weatherIcon];
